import React from "react";
import { LegendRowStyled, LegendLabelStyled, LegendItemStyled, LegendDotStyled } from "../orgDesign.styles";
import { STATUS_LABELS, getRoleChangeConfig } from "../orgDesign.constants";

// All 5 statuses the backend/tree engine actually supports (STATUS_LABELS'
// own keys — see orgDesignTreeEngine.js's STATUSES) — no future/unsupported
// role type is introduced here. Each dot's color comes from
// getRoleChangeConfig, the same lookup driving every tree node's own accent
// border + status tag, so the legend can never drift out of sync with what
// the nodes actually show. `entryOption` swaps AUGMENTED's label to
// "Increased" for a from-scratch (existing-org) workspace — see
// getRoleChangeConfig.
const RoleChangeLegend = ({ entryOption }) => (
  <LegendRowStyled>
    <LegendLabelStyled>Role Changes</LegendLabelStyled>
    {Object.keys(STATUS_LABELS).map((status) => {
      const config = getRoleChangeConfig(status, entryOption);
      return (
        <LegendItemStyled key={status}>
          <LegendDotStyled $accentToken={config.accentToken} />
          {config.label}
        </LegendItemStyled>
      );
    })}
  </LegendRowStyled>
);

export default RoleChangeLegend;
